/* eslint-disable import/no-unresolved */
import { ReactText } from 'react';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import OrderSectionPopoverContent from 'components/popover/OrderSectionPopoverContent';
import Render from 'components/render';
import { round } from 'helpers';
import RightArrowIcon from 'styles/assets/icons/RightArrowIcon';
import { PopoverWithCustomIcon } from 'UIKit';

import styles from './index.module.scss';

const getBarsClassName = (num: number) => {
  let color = '';
  if (num <= 10) {
    color = 'shade-1';
  } else if (num > 10 && num <= 20) {
    color = 'shade-2';
  } else if (num > 20 && num <= 25) {
    color = 'shade-3';
  } else if (num > 25 && num <= 30) {
    color = 'shade-4';
  } else if (num > 30 && num <= 40) {
    color = 'shade-5';
  } else if (num > 40 && num <= 50) {
    color = 'shade-6';
  } else if (num > 50 && num <= 60) {
    color = 'shade-7';
  } else if (num > 60 && num <= 70) {
    color = 'shade-8';
  } else if (num > 70 && num <= 80) {
    color = 'shade-9';
  } else if (num > 80 && num <= 85) {
    color = 'shade-10';
  } else if (num > 85 && num <= 95) {
    color = 'shade-11';
  } else if (num > 95 && num <= 100) {
    color = 'shade-12';
  } else if (num > 100) {
    color = 'shade-13';
  }
  return color;
};

interface IMAndMMProps {
  initialMargin: ReactText;
  maintenanceMargin: ReactText;
  imPercentage: number;
  mmPercentage: number;
  showDetailsLink: boolean;
  redirectionLink?: string;
  handleLinkClick?: () => void;
}

const IMAndMMBarComponent = ({
  initialMargin,
  maintenanceMargin,
  imPercentage,
  mmPercentage,
  showDetailsLink,
  redirectionLink,
  handleLinkClick,
}: IMAndMMProps) => {
  const { t } = useTranslation(['portfolioMargin']);

  return (
    (<PopoverWithCustomIcon
      iconComponent={
        <div className={styles.progress} data-palette="IMAndMMBarComponent">
          <div className={styles['bar-container']}>
            <span>IM</span>
            <span className={`${styles.bar} ${styles[getBarsClassName(imPercentage)]}`} />
            <span className={styles.percentage}>
              {imPercentage && Number(initialMargin) > 0
                ? `(${imPercentage}%)`
                : '(0.00%)'}
            </span>
          </div>
          <div className={styles['bar-container']}>
            <span>MM</span>
            <span className={`${styles.bar} ${styles[getBarsClassName(mmPercentage)]}`} />
            <span className={styles.percentage}>
              {mmPercentage && Number(maintenanceMargin) > 0
                ? `(${mmPercentage}%)`
                : '(0.00%)'}
            </span>
          </div>
        </div>
      }
      popoverComponent={
        <OrderSectionPopoverContent
          text={
            <div className={styles.marginDataPopover} data-palette="IMAndMMBarComponent">
              <div className={styles.marginContainer}>
                <span className={styles.title}>IM: </span>
                <span>
                  <span className={styles.value}>{round(initialMargin, 2)}</span>
                  <span> USDT </span>
                  <span className={styles.percentage}>
                    {imPercentage && Number(initialMargin) > 0
                      ? `(${imPercentage}%)`
                      : '(0.00%)'}
                  </span>
                </span>
              </div>
              <div className={styles.marginContainer}>
                <span className={styles.title}>MM: </span>
                <span>
                  <span className={styles.value}>{round(maintenanceMargin, 2)}</span>
                  <span> USDT </span>
                  <span className={styles.percentage}>
                    {mmPercentage && Number(maintenanceMargin) > 0
                      ? `(${mmPercentage}%)`
                      : '(0.00%)'}
                  </span>
                </span>
              </div>
              <Render when={showDetailsLink}>
                <Link
                  data-testid="see-details-link"
                  to={redirectionLink}
                  onClick={handleLinkClick}
                  className={styles.link}
                >
                  {t('portfolioMargin:banner_label')}
                  <RightArrowIcon fillColor="var(--brand-bg-primary)" />
                </Link>
              </Render>
            </div>
          }
        />
      }
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
    />)
  );
};

export default IMAndMMBarComponent;
